import { GET_PRIORITIES_REQUEST, GET_PRIORITIES_SUCCESS, GET_PRIORITIES_FAILURE } from '../actions/priorities';

const initialState = {
    priorities: [],
    fetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PRIORITIES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_PRIORITIES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                priorities: action.payload.priorities
            };
        }
        case GET_PRIORITIES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        default:
            return state;
    }
};
